// React
import { useState } from "react";

// Estilos
import style from "./home.module.css";

// Layout
import NavBarLeft from "../../components/navBarLeft/navBarLeft";
import Header from "../../components/header/header";

// Bodies
import BodyPeopleBody from "../../components/bodyPeopleBody/bodyPeopleBody";
import BodyPeopleBodyEFNI from "../../components/bodyPeopleBodyEFNI/bodyPeopleBodyEFNI";
import BodyReportBody from "../../components/bodyReportBody/bodyReportBody";
import BodyPeopleApresentacao from "../../components/bodyPeopleApresentacao/bodyPeopleApresentacao";
import BodyDataBody from "../../components/bodyDataBody/BodyDataBody";
import BodyDataBodyApresentacao from "../../components/bodyDataBodyApresentacao/BodyDataBodyApresentacao";

/* ---------------------------- Constantes ---------------------------- */

// Tipos de páginas
const PAGES = {
  PEOPLE: "people",
  EFNI: "efni",
  REPORT: "report",
  APRESENTACAO: "apresentacao",
  RELATORIO_APRESENTACAO: "relatorioApresentacao",
  DATA: "data",
};

// Mapeamento página -> componente
const PAGE_COMPONENTS = {
  [PAGES.PEOPLE]: BodyPeopleBody,
  [PAGES.EFNI]: BodyPeopleBodyEFNI,
  [PAGES.REPORT]: BodyReportBody,
  [PAGES.APRESENTACAO]: BodyPeopleApresentacao,
  [PAGES.RELATORIO_APRESENTACAO]: BodyDataBodyApresentacao,
  [PAGES.DATA]: BodyDataBody,
};

// Páginas que usam layout "Data"
const DATA_LAYOUT_PAGES = [PAGES.RELATORIO_APRESENTACAO, PAGES.DATA];

function Home() {
  /* ----------------------------- Estado ----------------------------- */

  const [page, setPage] = useState(PAGES.PEOPLE);

  /* ----------------------------- Helpers ---------------------------- */

  // Define componente da página atual
  const CurrentBody = PAGE_COMPONENTS[page] || BodyDataBody;

  // Define layout conforme tipo de página
  const isDataLayout = DATA_LAYOUT_PAGES.includes(page);

  /* ------------------------------ JSX ------------------------------- */

  return (
    <div className={style["App"]}>
      {/* Menu lateral */}
      <div className={style["menubar"]}>
        <NavBarLeft page={setPage} />
      </div>

      {/* Conteúdo principal */}
      <div
        className={
          isDataLayout ? style["BodyHeader-Data"] : style["BodyHeader"]
        }
      >
        {/* Header fixo */}
        <div className={style["header"]}>
          <Header />
        </div>

        {/* Corpo dinâmico */}
        <div className={isDataLayout ? style["body-Data"] : style["body"]}>
          <CurrentBody />
        </div>
      </div>
    </div>
  );
}

export default Home;
